import React, { useState, useEffect } from 'react';
import ReferenceCard from 'components/Cards/ReferenceCard';
import ToggleDetail from 'components/ToggleDetail';
import ReferenceFormWrapper from 'components/Forms/ReferenceFormWrapper/FormWrappers';
import { get } from 'services';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { connect } from 'react-redux';
import WarningNotiifcation from 'components/WarningNotification';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const ReferenceModule = ({ user }) => {
  const [showDetail, setShowDetail] = useState(true);
  const [profesionNames, setProfesionNames] = useState([]);
  const [parentescos, setParentescos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)
        const response = await get(`PersonaReferencia/GetByPersonaId/${user.persona.id}`);
        user.persona.personaReferencias = response.data

        if (user.persona.personaReferencias && user.persona.personaReferencias.length > 0 && user.persona.personaReferencias.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        // const profesion = await get('Profesion')
        // setProfesionNames(profesion.data)

        const parentescosDB = await get('Parentesco');
        setParentescos(parentescosDB.data)
      } catch (error) {
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();

    return function cleanup() {
      setProfesionNames([]);
      setParentescos([])
    };
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail} onToggleDetail={setShowDetail} label="Referencias" />
        {
          showDetail ?
            <div>
              {
                (user.persona && user.persona.personaReferencias && user.persona.personaReferencias.length > 0 && user.persona.personaReferencias.filter(x => x && x.estado == 1).length > 0)
                  ? (
                    user.persona.personaReferencias.filter(x => x && x.estado == 1).map((referencia) => {
                      return <ReferenceCard
                        key={referencia.id}
                        referencia={referencia}
                        profesionNames={profesionNames}
                        parentescos={parentescos}
                        referenceType={referencia.laboral == 1 ? "Laboral" : "Personal"} />
                    })
                  )
                  : <Form.Group as={Col} md="12">
                    <WarningNotiifcation message='No ha agregado ' enphasis='referencias' />
                  </Form.Group>
              }
            <Navigation beforeUrl="/experience" continueUrl="/jobAppliedInformation" />
            </div>
            :
            <div>
              <ReferenceFormWrapper />
            </div>
        }
      </div>
    </>
  )
}
const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(ReferenceModule);
